import React from "react";
import OccupancyHeaderWithLimits from "./OccupancyHeaderWithLimits";
import OccupancyHeaderPlain from "./OccupancyHeaderPlain";
const translate = require('../../translate');

const Header = ({ connectionStatus, occupancy, max_occupancy, critical_occupancy, language, isOpen }) => {
    if (connectionStatus === 'Error') {
        return <div className="card-title h5 text-center" style={{fontSize: '500%'}}>
            {translate(language, 'Connection Error')}
        </div>;
    } else if (!isOpen) {
        return <div className="card-title h5 text-center" style={{ fontSize: '500%' }}>
            {translate(language, 'Closed')}
        </div>;
    } else {
        return max_occupancy ?
            <OccupancyHeaderWithLimits language={language} max_occupancy={max_occupancy}
                                       critical_occupancy={critical_occupancy} occupancy={occupancy}/> :
            <OccupancyHeaderPlain occupancy={occupancy} language={language}/>;
    }
}

export default Header;